// @vendor
const React = require('react');

// @components
const {
    OneLineSymbolAmount,
} = require('commonsComponents/oneLineSymbolAmount');

// @helpers
const { getLanguage } = require('core/i18n').i18n;
const {
    formatAmountObject,
    getPlainAmountObject,
    formatWithoutRound,
    formatCurrency,
} = require('utilities/currencyHelper');

const formatValue = (amount, currency) => {
    const plainAmountObject = getPlainAmountObject({
        amount: amount,
        currency: currency,
    });
    return (
        <OneLineSymbolAmount
            amountObject={plainAmountObject}
            language={getLanguage()}
            amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
        />
    );
};

const buildAbsoluteFormattedValue = object => {
    const importe = Math.abs(object.amount);
    const value = formatWithoutRound(importe, 2);
    const currency = formatCurrency(object.currency);
    return `${value} ${currency}`;
};

module.exports = {
    formatValue,
    buildAbsoluteFormattedValue,
};
